import React from "react";
import { parseTextWithEnviromentVariables } from "@/utils";
import "./styles.scss";

interface RichtextProps {
  content: string | string[];
  t?: { [key: string]: string } | ((key: string) => string);
  siteDataComplete: any;
  customClass?: string;
}

const Richtext: React.FC<RichtextProps> = ({ content, t, siteDataComplete, customClass }) => {
  if (!content) return null;

  const contentArray = Array.isArray(content) ? content : [content];

  const html = contentArray
    .map((item) => {
      const translatedItem = t ? (typeof t === "function" ? t(item) : t[item] || item) : item;

      return parseTextWithEnviromentVariables(
        translatedItem,
        siteDataComplete,
        siteDataComplete?.company_name
      );
    })
    .join("");

  return (
    <div
      data-testid="rich-text"
      className={`richText u-editor ${customClass || ""}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default Richtext;
